import { PriceAvailabilityRequestStatus } from '../../../../../../types/PriceAvailabilityRequestsStatus';
import { Text } from '../../../../../cdl/Text/Text';
import { translate } from '../../../../../common/helpers/translate.helper';
import { useFlags } from '../../../../../common/launchDarkly/useFlags';
import { usePriceAvailabilityCheck } from '../../../../../offer/OfferOverview/actions/usePriceAvailabilityCheck';
import { useOfferCardContext } from '../../../components/OfferCard/hooks/useOfferCardContext';

const getStatusMessage = (status: PriceAvailabilityRequestStatus): string | null => {
    switch (status) {
        case PriceAvailabilityRequestStatus.FULL_AVAILABILITY:
        case PriceAvailabilityRequestStatus.PARTIAL_AVAILABILITY:
            return translate('offer.priceAvailability.statusChecked');
        case PriceAvailabilityRequestStatus.OPEN:
            return translate('offer.priceAvailability.statusPending');
        default:
            return null;
    }
};

export const PriceAvailabilityStatus = () => {
    const { offer } = useOfferCardContext();
    const flags = useFlags();

    const { data: paiData } = usePriceAvailabilityCheck({
        offerId: offer.id,
    });

    if (!flags.priceAvailabilityRequest || !paiData?.hasPAI || !paiData.request) {
        return null;
    }

    const statusMessage = getStatusMessage(paiData.request.status);

    if (!statusMessage) {
        return null;
    }

    return (
        <Text variant="action" color="foreground.muted">
            {statusMessage}
        </Text>
    );
};
